export enum SetCardListActionTypes {
  FETCHING = 'set-cards/FETCHING',
  RECEIVED = 'set-cards/RECEIVED',
  FILTERED = 'set-cards/FILTERED',
}
